var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":"","color":"accent","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.accept}},[_vm._v(_vm._s(_vm.$t('message.common.publish')))])}
var staticRenderFns = []

export { render, staticRenderFns }